import { Options, Vue } from 'vue-property-decorator';
import { namespace } from 's-vuex-class';
import { NotificationState } from '@/store/modules/notification/types';

const notification = namespace('notification');

@Options({})
export default class NotificationProviderComponent extends Vue {
  @notification.Getter private readonly notificationValue!: NotificationState;
  @notification.Action private readonly hideNotification!: () => void;

  get isShow() {
    if (this.notificationValue.message) {
      return true;
    } else {
      return false;
    }
  }

  close() {
    this.hideNotification();
  }
}
